import React from 'react';
import PropTypes from 'prop-types';
import SMMapHelper from 'components/helpers/SMMapHelper.js';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMMasterResource from 'resources/SMMasterResource';
import SMSpaceResource from 'resources/SMSpaceResource';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMOSpaceEditMenuView from './SMOSpaceEditMenuView';
import SMOSpaceEditBasicFragment from './fragments/SMOSpaceEditBasicFragment';
import SMOSpaceEditAddressFragment from './fragments/SMOSpaceEditAddressFragment';
import SMOSpaceEditTextFragment from './fragments/SMOSpaceEditTextFragment';
import SMOSpaceEditTermsFragment from './fragments/SMOSpaceEditTermsFragment';
import reactMixin from 'react-mixin';

class SMOSpaceEditView extends React.Component {

  constructor(props) {
    super(props);
    this.geocoder = null;
    this.sendingPostSpace = false;
    this.formRequest = null;

    this.state = {
      display: this.props.display,
      page: this.props.page,
      listItems: [],
      areas: [],
      selectedRowIndex: 0,
      owner: this.props.owner ? this.props.owner.attributes : null,
      space: this.props.space ? this.props.space.attributes : null,
      errors: []
    };
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);

    SMMasterResource.getLargeAreas((this.state.space.country_id != undefined) ? this.state.space.country_id : 1, (data, error, xhr)=>{
      this.setState({
        areas: data
      });
    });
    this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {

  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {

  }

  nextButtonDidSelect(x) {
    this.setState({selectedRowIndex: this.state.selectedRowIndex + 1});
    $(this.refs.formContent).scrollTop(0);
  }

  //chrome住所入力対応
  postOrUpdateSpace(id, formData, queries, completion){
    if (this.sendingPostSpace) {
      return null;
    } else if (this.state.space.id) {
      return SMSpaceResource.updateSpace(id, formData, queries, completion);
    } else {
      this.sendingPostSpace = true;
      return SMSpaceResource.postSpace(formData, queries, completion);
    }
  }

  actionButtonDidClick(status, e) {
    e.preventDefault();
    let currentTarget = e.currentTarget;
    let formData = new FormData(this.refs.form);
    formData.append("status", status);

    if (this.formRequest) this.formRequest.abort();
    if (this.state.space.id) {
      SMSpaceResource.updateSpace(this.state.space.id, formData, {}, function(data, error, xhr){});
    }
    location.href = currentTarget.href;
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.formContent);

    $mainTable.outerHeight(this.mainTableHeight() - 74);
    this.mainTableFooterSizeToFit();
  }

  tableDidSelectRowAtIndex(rowIndex) {
    this.setState({selectedRowIndex: rowIndex});
    $(this.refs.formContent).scrollTop(0);
  }

  updateSpace(name, value){
    $(document).trigger("SMSpaceDidStartToUpdate", [name, value]);
    let responseHandler = (data, error, xhr)=>{
      this.formRequest = null;
      this.sendingPostSpace = false;
      if (error == "abort") return;
      let errors = xhr.responseJSON.errors;
      if (xhr.status == 200 || xhr.status == 201) {
        SMHistoryHelper.replaceState(Routes.edit_owner_dashboard_space_path(
          this.state.owner.username, data.username), this.state);

        this.setState({space: data, errors: errors});
        $(this.refs.formContent).showSuccessMessage(I18n.t("dashboard.notice_000001"));
        $(document).trigger("SMSpaceDidUpdateSuccess", [name, value]);
      } else if (xhr.status == 400) {
        this.setState({errors: errors});
        $(document).trigger("SMSpaceDidFailToUpdate", [name, value, errors]);
      } else {
        $(document).trigger("SMSpaceDidFailToUpdate", [name, value, errors]);
      }
    };

    this.setState(function(previousState, currentProps) {
      if (name == 'latlng') {
        let latlng = value.split(',');
        previousState.space.latitude = latlng[0];
        previousState.space.longitude = latlng[1];
      } else {
        previousState.space[name] = value;
      }
      return {space: previousState.space};
    });

    let formData = new FormData(this.refs.form);
    if (this.formRequest) this.formRequest.abort();
    this.formRequest = this.postOrUpdateSpace(this.state.space.id, formData, {}, responseHandler);
  }

  // delegate
  formDidUpdate(e) {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;

    if (name === 'postal_code' && this.state.space.country_id === 1) {
      if (!this.geocoder) this.geocoder = new google.maps.Geocoder();

      this.geocoder.geocode({address: value}, (results, status) => {
        const address = SMMapHelper.getAddress(results, status);
        if (!address) return;
        const latlng = results[0].geometry.location;

        const space = this.state.space;
        for (let i = 0; i < this.state.areas.length; i++) {
          let area = this.state.areas[i];
          if (area.name_text === address.prefecture) {
            space.state = area.name;
            space.state_text = area.name_text;
          }
        }
        space.city = address.city;
        space.address_1 = address.address_1;
        space.postal_code = value;
        space.latitude = latlng.lat();
        space.longitude = latlng.lng();

        this.setState({space: space});
        this.updateSpace(name, value);
      });
    } else if (name == 'state' || name == 'city' || name == 'address_1' || name == 'address_2') {
      let space = this.state.space;
      space[name] = value;
      if (name == 'state') {
        for (let i = 0; i < this.state.areas.length; i++) {
          let area = this.state.areas[i];
          if (area.name == name) {
            space.state_text = area.name_text;
            break;
          }
        }
      }
      this.setState({space: space});

      if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
      let address = this.state.space.state_text + ' ' + this.state.space.city + ' ' + this.state.space.address_1 + ' ' + this.state.space.address_2;
      this.geocoder.geocode({address: address}, (results,status)=>{
        if (status == 'OK') {
          let latlng = results[0].geometry.location;
          space.latitude = latlng.lat();
          space.longitude = latlng.lng();
          this.setState({space: space});
        }
        this.updateSpace(name, value);
      });
    } else {
      this.updateSpace(name, value);
    }
  }

  googleMapDragEnd(e) {
    this.updateSpace('latlng', e.latLng.lat() + ',' + e.latLng.lng());
  }

  render() {
    return (
      <div className="dashboard-container clearfix mb30">
        <SMOSpaceEditMenuView delegate={this} owner={this.state.owner} space={this.state.space} selectedRowIndex={this.state.selectedRowIndex} action={this.props.action} />
        <div id="js-split_view-main" ref="formContent" className="dashboard-maincol__right js-scroller">
          <form ref="form">
            <input type="hidden" name="owner_id" defaultValue={this.state.space.owner_id} />
            <SMOSpaceEditBasicFragment delegate={this} space={this.state.space} spaceTypes={this.props.spaceTypes} fragmentIndex={0} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
            <SMOSpaceEditAddressFragment delegate={this} space={this.state.space} areas={this.state.areas} fragmentIndex={1} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
            <SMOSpaceEditTextFragment delegate={this} space={this.state.space} fragmentIndex={2} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
            <SMOSpaceEditTermsFragment delegate={this} owner={this.state.owner} space={this.state.space} fragmentIndex={3} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          </form>
        </div>
      </div>
    );
  }
}

SMOSpaceEditView.propTypes = {
  owner: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
  spaceTypes: PropTypes.array.isRequired,
  action: PropTypes.string.isRequired,
};
reactMixin(SMOSpaceEditView.prototype, SMSplitViewMixin);
export default SMOSpaceEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceEditView.jsx